export default __webpack_public_path__ + "static/media/arrowLeft.ea564861.svg";